module.exports = {
      id: "back-icon-usage",
      viewBox: "0 0 7.828 12.828",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#back-icon",
      toString: function () {
        return this.url;
      }
    }